import { CMSLink } from '@/components/Link'
import RichText from '@/components/RichText'
import Image from 'next/image'

export const ImageOverlayButtonCard = (fence: any) => {
  if (!fence?.image?.url) {
    return null
  }
  return (
    <div className="relative  group h-full flex flex-col">
      <div className="relative block overflow-hidden flex-1 picture-rounded">
        <div className="relative overflow-hidden block z-[1] h-full">
          <Image
            src={fence?.image?.url}
            alt={fence?.image?.alt || ''}
            fill
            className="w-full h-full object-cover transition-all ease-in-out duration-100 group-hover:scale-110"
            sizes="(max-width: 640px) 400px, (max-width: 768px) 450px, (max-width: 1024px) 500px, 617px"
            priority={false}
            quality={65}
          />
        </div>

        <div className=" absolute left-0 top-0 bottom-0 w-full h-full bg-secondary group-hover:z-[2] opacity-0 group-hover:opacity-100 pointer-events-none transition-all duration-1000 transform  group-hover:translate-y-full"></div>
      </div>
      <div className=" flex flex-col absolute bottom-[5px] left-[5px] right-[30px] transition-all delay-200 duration-1000 ease-in-out origin-bottom scale-y-0 z-[2] group-hover:scale-y-100">
        {fence?.title && (
          <RichText
            data={fence.title}
            enableGutter={false}
            enableProse={false}
            className="w-[50%] relative inline-block text-lg sm:text-xl md:text-2xl lg:text-3xl font-semibold mb-2 pt-4 line-clamp-2 break-words text-black bg-primary px-[30px] py-[11px] rounded-tl-[20px] rounded-tr-[20px]"
          />
        )}
        {fence?.links?.length > 0 && (
          <div className="relative inline-block bg-primary px-6 py-2 rounded-[20px] rounded-tl-none">
            {fence?.links?.map((item: any, index: any) => {
              const link = item.link
              return (
                <CMSLink
                  key={index}
                  {...link}
                  className=" text-[16px] font-light tracking-[0] leading-[20px] whitespace-nowrap bg-transparent hover:bg-transparent text-primary-foreground transition-all duration-300 [font-family:'Open_Sans',Helvetica] hover:text-primary-foreground"
                />
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}
